import { PanelLeftClose, PanelLeftOpen } from "lucide-react";
import { Logo } from "@/components/brand/Logo";
import { NotificationBell } from "@/components/notifications/NotificationBell";
import { cn } from "@/lib/utils";
import { NavList } from "./NavList";
import { ThemeToggle } from "./ThemeToggle";
import { UserMenu } from "./UserMenu";

export const Sidebar = ({ collapsed, onToggle }) => (
  <aside
    data-testid="app-sidebar"
    className={cn(
      "hidden md:flex print:!hidden fixed inset-y-0 left-0 z-30 flex-col border-r bg-card transition-[width] duration-300 ease-out",
      "border-brand-gold/20 dark:border-brand-line",
      collapsed ? "w-[76px]" : "w-[260px]",
    )}
  >
    <div className={cn("flex h-20 items-center", collapsed ? "justify-center px-2" : "justify-between px-6")}>
      {collapsed ? (
        <Logo variant="symbol" className="h-9 w-auto" testId="sidebar-logo-symbol" />
      ) : (
        <>
          <Logo variant="wordmark" className="h-9 w-auto" testId="sidebar-logo-full" />
          <NotificationBell side="right" align="start" className="-mr-2" />
        </>
      )}
    </div>
    {collapsed && <div className="flex justify-center pb-2"><NotificationBell side="right" align="start" /></div>}
    <div className={cn("gold-rule", collapsed ? "mx-3" : "mx-6")} />
    <div className={cn("flex-1 overflow-y-auto py-6", collapsed ? "px-3" : "px-4")}>
      <NavList collapsed={collapsed} />
    </div>
    <div className={cn("gold-rule", collapsed ? "mx-3" : "mx-6")} />
    <div className={cn("flex flex-col gap-1 py-4", collapsed ? "px-3 items-center" : "px-4")}>
      <ThemeToggle compact={collapsed} className={collapsed ? "w-11 justify-center px-0" : "w-full"} />
      <button
        type="button"
        onClick={onToggle}
        data-testid="sidebar-collapse-toggle"
        aria-label={collapsed ? "Espandi barra laterale" : "Comprimi barra laterale"}
        className={cn(
          "inline-flex h-10 items-center gap-2 rounded-xl text-sm text-muted-foreground hover:bg-accent hover:text-foreground transition-colors",
          collapsed ? "w-11 justify-center" : "w-full px-3",
        )}
      >
        {collapsed ? <PanelLeftOpen className="h-4 w-4" /> : <PanelLeftClose className="h-4 w-4" />}
        {!collapsed && <span>Comprimi</span>}
      </button>
      <div className="mt-2 w-full">
        <UserMenu compact={collapsed} />
      </div>
    </div>
  </aside>
);
